/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Save_Failed_TitleInputs */

const en_toast_save_failed_title = /** @type {(inputs: Toast_Save_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save failed`)
};

const de_toast_save_failed_title = /** @type {(inputs: Toast_Save_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Save failed" |
*
* @param {Toast_Save_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_save_failed_title = /** @type {((inputs?: Toast_Save_Failed_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Save_Failed_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_save_failed_title(inputs)
	return de_toast_save_failed_title(inputs)
});